import retina from 'retinajs';
retina();